export const url = "https://api.ipest.com.br/REST/SOIPESWS/";

export const AuthFetchJson = async (
  url: string,
  req: RequestInit | undefined = undefined,
) => {
  const token = localStorage.getItem("IPEST-TOKEN") || "";

  return fetch(url, {
    ...req,
    headers: {
      "Content-Type": "application/json",
      "IPEST-TOKEN": token,
      "tenantid": "01,01",
      "Authorization": `Basic YWRtaW46U29sQDI1MDA2NiE=`,
      ...((req?.headers as Record<string, string>) ?? {}),
    },
  }).then(async (res) => {
    const text = await res.text();
    // eslint-disable-next-line no-control-regex
    const sanitized = text
      // eslint-disable-next-line no-control-regex
      .replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, " ")
      .replace(/\n|\r/g, " ");
    try {
      return JSON.parse(sanitized);
    } catch (e) {
      return {
        sucesso: "F",
        dados: [],
        mensagem: "Erro ao processar resposta do servidor.",
      };
    }
  });
};
